export type GraphQLResponse<T> = {
  data?: T;
  errors?: Array<{ message: string }>;
};

interface FetchGraphQLOptions {
  url: string;
  token: string;
  query: string;
  headers?: Record<string, string>;
}

/**
 * Posts a GraphQL query and returns the typed response data.
 * Throws on HTTP errors, GraphQL errors, and missing data.
 */
export const fetchGraphQL = async <T>(options: FetchGraphQLOptions): Promise<T> => {
  const { url, token, query, headers = {} } = options;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    body: JSON.stringify({ query }),
  });

  if (!response.ok) {
    throw new Error(`GraphQL request failed: ${response.status}`);
  }

  const result: GraphQLResponse<T> = await response.json();

  if (result.errors?.length) {
    throw new Error(result.errors[0].message);
  }

  if (!result.data) {
    throw new Error('No data returned from GraphQL');
  }

  return result.data;
};
